import {GTMEvent, PreferencesAction, propertyConfiguratorAnalytics} from "../analytics/events";

export const trackCheckbox = (checked: boolean, label: string, eventAction: PreferencesAction, isOnSidebar?: boolean) => {
    const suffix = checked ? "add" : "delete";
    propertyConfiguratorAnalytics.gtm.propertyConfiguratorEvent(
        isOnSidebar ? GTMEvent.FLAT_CONFIG_SIDEBAR : GTMEvent.FLAT_CONFIG_MODAL,
        {
            preferences_action: eventAction,
            preferences: label
        },
        suffix
    );
};
import {GTMEvent, PreferencesAction, propertyConfiguratorAnalytics} from "../analytics/events";

export const trackCheckbox = (checked: boolean, label: string, eventAction: PreferencesAction, isOnSidebar?: boolean) => {
    const suffix = checked ? "add" : "delete";
    propertyConfiguratorAnalytics.gtm.propertyConfiguratorEvent(
        isOnSidebar ? GTMEvent.FLAT_CONFIG_SIDEBAR : GTMEvent.FLAT_CONFIG_MODAL,
        {
            preferences_action: eventAction,
            preferences: label
        },
        suffix
    );
};
